import styled from "styled-components";
import WarningIcon from "panel/src/assets/images/warning.svg";

export default styled.img.attrs({ src: WarningIcon })`
  margin-top: 16px;
  margin-bottom: 24px;
`;
